import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Bat from "../../assets/battery.jpg";

const BatteryReplacement = () => {
  return (
    <>
      <SeoHead
        title="Car Battery Testing & Replacement in Temecula | Advanced Automotive Smog"
        description="Battery testing and replacement in Temecula. We check your current battery and install a reliable replacement so your car starts when you need it to."
        path="/services/battery-replacement"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Battery Replacement"
          path="/services/battery-replacement"
          description="Battery testing and replacement in Temecula. We check your current battery and install a reliable replacement."
          serviceType="Battery replacement"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Bat}
                alt="Car battery replacement service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Electrical System Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Battery Replacement
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              A weak or dead battery can leave you stranded when you least expect it.
              We provide fast, reliable battery testing and replacement so your
              vehicle starts strong every time.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is Battery Replacement?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Your battery powers the starter motor and all electrical systems in
              your car. As it ages, it loses the ability to hold a charge—leading to
              slow starts, dashboard issues, and eventually a breakdown.
              <br />
              <br />
              Our service includes testing your current battery, installing a new
              premium-quality battery, and ensuring it meets or exceeds factory
              specifications.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Fast and accurate battery diagnostics</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality batteries for all makes and models</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional installation and system check</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Warranty-backed battery replacements</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Tips to extend battery lifespan</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default BatteryReplacement;






